import React from 'react';
import { Alert } from '@tencent/spaui';
import { Agency, AgencyStatus } from 'model/agency';
import AuthorizeFile from './authorize_file';

const statusConfig: any = {
  [AgencyStatus.pending]: {
    type: 'warning',
    label: '待审核',
    desc: () => (
      <div>
        <div style={{ display: 'inline-block', verticalAlign: 'text-bottom', paddingRight: '8px' }}>
          您的资料审核已提交，我们会在1-7个工作日内进行处理，请耐心等待。
        </div>
        <AuthorizeFile />
      </div>
    ),
  },
  [AgencyStatus.toAccept]: {
    type: 'info',
    label: '审核中',
    desc: () => (
      <div>
        <div style={{ display: 'inline-block', verticalAlign: 'text-bottom', paddingRight: '8px' }}>
          您的入驻申请已进入评审环节，请留意平台相关信息。
        </div>
        <AuthorizeFile />
      </div>
    ),
  },
  [AgencyStatus.toActivate]: {
    type: 'info',
    label: '审核中',
    desc: () => (
      <div>
        <div style={{ display: 'inline-block', verticalAlign: 'text-bottom', paddingRight: '8px' }}>
          您的入驻申请已进入评审环节，请留意平台相关信息。
        </div>
        <AuthorizeFile />
      </div>
    ),
  },
  [AgencyStatus.reject]: {
    type: 'error',
    label: '审核未通过',
    desc: (msg: string) => (
      <div>
        <div>您的资料审核未通过，原因为：{<span className="error">{msg}</span> || '-'}</div>
        <AuthorizeFile />
      </div>
    ),
  },
  // [AgencyStatus.pause]: {
  //   type: 'error',
  //   label: '审核未通过',
  //   desc: (msg: string) => <div>您的资料审核未通过，原因为：{<span className="error">{msg}</span> || '-'}</div>,
  // },
  [AgencyStatus.pass]: {
    type: 'success',
    label: '审核通过',
    desc: () => (
      <div>
        您的资料审核已通过，可以前往 <a href="/manage/application">应用管理</a> 添加应用
      </div>
    ),
  },
};
// pause 储备状态认为是通过
statusConfig[AgencyStatus.pause] = statusConfig[AgencyStatus.pass];

console.log('statusConfig', statusConfig);

const AuditStatus: React.FC<{ data: Agency }> = (props) => {
  const { status, audit_msg } = props.data;
  if (!status || !statusConfig[status]) {
    return null;
  }
  const { type, label, desc } = statusConfig[status];

  return <Alert type={type} title={label} desc={desc(audit_msg)} />;
};

export default AuditStatus;
